const Loader = ({ styles }: any) => {
    return (
        <div className={`w-full h-screen flex items-center justify-center flex-col gap-[15px] bg-white dark:bg-bgDarkDull ${styles}`}>
            <h1 className="text-primary font-bold text-2xl max-w-[200px] text-center flex items-center gap-[4px] uppercase tracking-wide">Loading
                <div className="loader">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </h1>
        </div>
    );
};

export default Loader;